function setActivePredictiveSearchTab(predictiveSearch, tabName) {
  const tabs = predictiveSearch.querySelectorAll('.predictive-search__tab');
  const panels = predictiveSearch.querySelectorAll('[data-tab-panel]');

  tabs.forEach((tab) => {
    tab.classList.toggle('is-active', tab.dataset.tab === tabName);
  });

  panels.forEach((panel) => {
    panel.classList.toggle('is-active', panel.dataset.tabPanel === tabName);
  });
}

function activateFirstAvailablePredictiveSearchTab(predictiveSearch) {
  if (!predictiveSearch) return;

  const priorityOrder = ['products', 'pages', 'suggestions'];

  for (const tabName of priorityOrder) {
    const panel = predictiveSearch.querySelector(
      `[data-tab-panel="${tabName}"]`
    );

    if (!panel) continue;

    const hasResults = panel.querySelector('.predictive-search__list-item');

    if (hasResults) {
      setActivePredictiveSearchTab(predictiveSearch, tabName);
      return;
    }
  }
}

const mobilePredictiveResults = document.getElementById('MobileHeaderPredictiveResults');

if (mobilePredictiveResults) {
  const observer = new MutationObserver(() => {

    const hasTabs = mobilePredictiveResults.querySelector('.predictive-search__tab');
    if (!hasTabs) return;

    setTimeout(() => {
      activateFirstAvailablePredictiveSearchTab(mobilePredictiveResults);
    }, 50);
  });

  observer.observe(mobilePredictiveResults, {
    childList: true,
    subtree: true
  });
}

document.addEventListener('click', function (event) {
  const tab = event.target.closest('.predictive-search__tab');
  if (!tab) return;

  event.preventDefault();

  const predictiveSearch = tab.closest('.predictive-search');
  if (!predictiveSearch) return;

  setActivePredictiveSearchTab(predictiveSearch, tab.dataset.tab);
});